import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import FormGuarantee from '../../../../view/FormGuarantee';
import Data from '../../../../data/StatePromissoryNote.json';
import converter from 'number-to-words';
import moment from 'moment';
import Loading from '../../../../view/Loading';
import RequiredData from '../../../../model/RequiredData';
import FormFinal from '../../../../view/FormFinal';
import {Pronoun} from '../../../../model/Helper';
import Meta from '../../../../model/Meta';

class PromissoryNoteStep4 extends Component {

    constructor(props){
        super(props);
        this.state = Data;
    }

    componentWillMount() {
        if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details
			},			
				()=>{
					RequiredData.lender(this.state, this.state.formPath+"/1");
                    RequiredData.borrower(this.state, this.state.formPath+"/2");
                    RequiredData.loan(this.state, this.state.formPath+"/3");
					localStorage.setItem(this.state.formId, JSON.stringify(this.state));
				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));

		}
    }

    componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

    handleChange(event) {
		const target = event.target;
	    const value = target.type === 'checkbox' ? target.checked : target.value;

	    this.setState({
			destinationEmail: value
		}, ()=>{
			let regex =/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if(regex.test(value)) {
				$(".download").addClass("btn-success").prop("disabled", false);
				$(".form-text").addClass("d-none");
			} else {
				$(".download").removeClass("btn-success").prop("disabled", true);
				$(".form-text").removeClass("d-none");
			}
		});
	}

    render() {

        let s = this.state.details.lender[0];
        let b = this.state.details.borrower[0];
        let l = this.state.details.loan;


        let blankLine = "____________________";

        let loanPrincipalNumber = l.principal ? parseFloat(l.principal.toLocaleString()) : 0;
        let loanPrincipalText = (typeof parseFloat(loanPrincipalNumber) === "number" && parseFloat(loanPrincipalNumber)>0) ?
        converter.toWords(loanPrincipalNumber) : 
        blankLine;
        let loanInterestRateNumber = l.interestRate ? parseFloat(l.interestRate) : 0;
        let loanInterestRateText = (typeof parseFloat(loanInterestRateNumber) === "number" && parseFloat(loanInterestRateNumber)>0) ?
        converter.toWords(loanInterestRateNumber) : 
        blankLine;
        let loanInterestRateBasis = l.interestRateBasis==="Monthly" ? `month` : `year`;
        let loanDurationNumber = l.duration ? parseFloat(l.duration) : 0;
        let loanDurationText = (typeof parseFloat(loanDurationNumber) === "number" && parseFloat(loanDurationNumber)>0) ?
        converter.toWords(loanDurationNumber) : 
        blankLine;
        let loanFirstInstallment = l.firstInstallment;
        let loanInterval = l.interval;
        let computationOfInterest = l.computationOfInterest;

        let monthlyAmort = 0;
        let loanInt = 0;
        
        if(l.interestRateBasis==="Monthly"){
            if(l.principalDemandable==="Pro rated on the number of installments"){
                loanInt = (loanPrincipalNumber*(loanInterestRateNumber/100))*loanDurationNumber;
                monthlyAmort = (loanPrincipalNumber+loanInt)/loanDurationNumber;
            }
            if(l.principalDemandable==="On the last installment"){
                loanInt = (loanPrincipalNumber*(loanInterestRateNumber/100))*loanDurationNumber;
                monthlyAmort = (loanInt)/loanDurationNumber;
            }
        }

        if(l.interestRateBasis==="Yearly"){
            loanInt = (loanPrincipalNumber*(loanInterestRateNumber/100))*loanDurationNumber;

            /**
             * Compute for the factor rate
             */
            let rateInDecimal = loanInterestRateNumber/100;
            let rateInDecimalPerMonth = rateInDecimal/12;
            let factorRate = rateInDecimalPerMonth / (1-(1+rateInDecimalPerMonth)**-(loanDurationNumber*12))
            //console.log("factor rate:", factorRate)

            if(loanInterval==="Monthly"){

                // Check computation of interest simple straigh or diminishing balance

                computationOfInterest==="Simple/Straight Computation" ?
                    monthlyAmort = (loanPrincipalNumber+loanInt)/(loanDurationNumber*12) :
                    monthlyAmort = (loanPrincipalNumber * factorRate ) // diminishing balance
                

            }
            if(loanInterval==="Yearly"){
                if(l.principalDemandable==="Pro rated on the number of installments"){
                    monthlyAmort = (loanPrincipalNumber+loanInt)/(loanDurationNumber);
                }
                if(l.principalDemandable==="On the last installment"){
                    monthlyAmort = (loanInt)/loanDurationNumber;
                }
            }
        }

        let lenderName = (s.lenderFname || s.lenderMname || s.lenderLname) ? 
                                (s.lenderFname+(s.lenderMname?` ${s.lenderMname}`:"")+(s.lenderLname?` ${s.lenderLname}`:"")+(s.lenderSuffix?` ${s.lenderSuffix}`:"")): 
                                blankLine;

        let lenderCorporationName = s.lenderCorporationName ? s.lenderCorporationName : blankLine;

        let borrowerName = (b.borrowerFname || b.borrowerMname || b.borrowerLname) ? 
                                (b.borrowerFname+(b.borrowerMname?` ${b.borrowerMname}`:"")+(b.borrowerLname?` ${b.borrowerLname}`:"")+(b.borrowerSuffix?` ${b.borrowerSuffix}`:"")): 
                                blankLine;
        
        let borrowerCorporationRepresentativeName = (b.borrowerCorporationRepresentativeFname || b.borrowerCorporationRepresentativeMname || b.borrowerCorporationRepresentativeLname) ? 
                                (b.borrowerCorporationRepresentativeFname+(b.borrowerCorporationRepresentativeMname?` ${b.borrowerCorporationRepresentativeMname}`:"")+(b.borrowerCorporationRepresentativeLname?` ${b.borrowerCorporationRepresentativeLname}`:"")+(b.borrowerCorporationRepresentativeSuffix?` ${b.borrowerCorporationRepresentativeSuffix}`:"")): 
                                blankLine;
        let borrowerCorporationName = b.borrowerCorporationName || blankLine;
        let borrowerCorporationRepresentativePosition = b.borrowerCorporationRepresentativePosition || blankLine;

        /**
         * Create schedule of payment
         */
        let scheduleOfPayment = `
            <table class="table table-bordered table-sm">
                <tbody>
        `;

        if(l.interestRateBasis==="Yearly" && loanInterval==="Monthly" && l.computationOfInterest==="Diminishing Balance") {
            scheduleOfPayment+=`<tr>
                <td class="font-weight-bold text-center">Payment Date</td>
                <td class="font-weight-bold text-center">Beginning Balance</td>
                <td class="font-weight-bold text-center">Amortization</td>
                <td class="font-weight-bold text-center">Principal</td>
                <td class="font-weight-bold text-center">Interest</td>
                <td class="font-weight-bold text-center">Ending Balance</td>
            </tr>`;
        } else {
            scheduleOfPayment+=`<tr>
                <td class="font-weight-bold text-center">Payment Date</td>
                <td class="font-weight-bold text-center">Amount</td>
                <td class="font-weight-bold text-center">Amortization</td>
                <td class="font-weight-bold text-center">Remaining Balance</td>
            </tr>`;
        }

        // Monthly
        if(l.interestRateBasis==="Monthly") {
            // Monthly -> On the last installment
            if(l.principalDemandable==="On the last installment"){

                [...Array(loanDurationNumber)].forEach((obj, i)=>{
                    scheduleOfPayment+=`
                        <tr key=${i}>
                            <td>
                                ${moment(loanFirstInstallment).add(i, 'month').format('LL')}
                            </td>
                            <td class="text-right">
                                ${Number((loanPrincipalNumber+loanInt)-(monthlyAmort*i)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                            </td>
                            <td class="text-right">
                                ${Number(monthlyAmort+((i+1===loanDurationNumber) ? loanPrincipalNumber : 0)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                            </td>
                            <td class="text-right">
                                ${Number((loanPrincipalNumber+loanInt)-((monthlyAmort*(i+1)+((i+1===loanDurationNumber) ? loanPrincipalNumber : 0)))).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                            </td>
                        </tr>
                    `;
                })
                
            }

            if(l.principalDemandable==="Pro rated on the number of installments"){

                [...Array(loanDurationNumber)].forEach((obj, i)=>{
                    scheduleOfPayment+=`
                        <tr key=${i}>
                            <td>
                                ${moment(loanFirstInstallment).add(i, 'month').format('LL')}
                            </td>
                            <td class="text-right">
                                ${Number((loanPrincipalNumber+loanInt)-(monthlyAmort*i)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                            </td>
                            <td class="text-right">
                                ${Number(monthlyAmort).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                            </td>
                            <td class="text-right">
                                ${Number((loanPrincipalNumber+loanInt)-((monthlyAmort*(i+1)))).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                            </td>
                        </tr>
                    `;
                })
                
            }

        }

        // Yearly
        if(l.interestRateBasis==="Yearly") {
            if(loanInterval==="Monthly") {
                if(l.computationOfInterest==="Simple/Straight Computation"){
                    [...Array(loanDurationNumber*12)].forEach((obj, i)=>{
                        scheduleOfPayment+=`
                            <tr key=${i}>
                                <td>
                                    ${moment(loanFirstInstallment).add(i, 'month').format('LL')}
                                </td>
                                <td class="text-right">
                                    ${Number((loanPrincipalNumber+loanInt)-(monthlyAmort*i)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number(monthlyAmort).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number((loanPrincipalNumber+loanInt)-((monthlyAmort*(i+1)))).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                            </tr>
                        `;
                    })
                }
                if(l.computationOfInterest==="Diminishing Balance"){
                    
                    let beginning, ending, principal, interest;

                    [...Array(loanDurationNumber*12)].forEach((obj, i)=>{

                        interest = i>0?ending * ((loanInterestRateNumber/100)/12) : loanPrincipalNumber * ((loanInterestRateNumber/100)/12);
                        
                        beginning = i>0?ending:loanPrincipalNumber - (i>0?(monthlyAmort-interest):0);
                        principal = monthlyAmort - interest;
                        ending = beginning - principal;

                        scheduleOfPayment+=`
                            <tr key=${i}>
                                <td>
                                    ${moment(loanFirstInstallment).add(i, 'month').format('LL')}
                                </td>
                                <td class="text-right">
                                    ${Number(beginning).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number(monthlyAmort).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number(principal).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number(interest).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number(ending).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                            </tr>
                        `;
                    })
                }
            }
            if(loanInterval==="Yearly"){
                if(l.principalDemandable==="On the last installment"){

                    [...Array(loanDurationNumber)].forEach((obj, i)=>{
                        scheduleOfPayment+=`
                            <tr key=${i}>
                                <td>
                                    ${moment(loanFirstInstallment).add(i, 'year').format('LL')}
                                </td>
                                <td class="text-right">
                                    ${Number((loanPrincipalNumber+loanInt)-(monthlyAmort*i)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number(monthlyAmort+((i+1===loanDurationNumber) ? loanPrincipalNumber : 0)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number((loanPrincipalNumber+loanInt)-((monthlyAmort*(i+1)+((i+1===loanDurationNumber) ? loanPrincipalNumber : 0)))).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                            </tr>
                        `;
                    })
                    
                }
    
                if(l.principalDemandable==="Pro rated on the number of installments"){
    
                    [...Array(loanDurationNumber)].forEach((obj, i)=>{
                        scheduleOfPayment+=`
                            <tr key=${i}>
                                <td>
                                    ${moment(loanFirstInstallment).add(i, 'year').format('LL')}
                                </td>
                                <td class="text-right">
                                    ${Number((loanPrincipalNumber+loanInt)-(monthlyAmort*i)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number(monthlyAmort).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                                <td class="text-right">
                                    ${Number((loanPrincipalNumber+loanInt)-((monthlyAmort*(i+1)))).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                </td>
                            </tr>
                        `;
                    })
                    
                }
            }
        }

        scheduleOfPayment+=`</tbody></table>`;

        let contract_html = `
        <style type="text/css">
            @import url("./css/styles.css");
            @import url("./css/styles-custom.css");
        </style>

        <div class="pdf">
            <div class="paper">
                
                <div class="paper-title text-center">
                    Promissory Note
                </div>

                <div>
                    <p>
                        FOR VALUE RECEIVED, the undersigned Maker, promises to pay to the order of <span class="dynamic-data text-uppercase font-weight-bold">${s.legalPersonality==="Natural Person" ? lenderName : lenderCorporationName}</span>, (hereinafter referred to as “Payee”), the principal amount of <span class="dynamic-data text-uppercase">${loanPrincipalText} Pesos (P${loanPrincipalNumber.toLocaleString()})</span>, plus interest of <span class="dynamic-data">${loanInterestRateText} percent (${loanInterestRateNumber}%)</span> per <span class="dynamic-data">${loanInterestRateBasis}</span> on the principal, for a duration of <span class="dynamic-data">${loanDurationText} (${loanDurationNumber}) ${loanInterestRateBasis}${loanDurationNumber>1?`s`:``}</span>. For convenience, a schedule of payment is hereby provided below, thus:
                    </p>
                </div>
                
                <div>${scheduleOfPayment}</div>

                <div>
                    <p>
                        This Promissory Note (hereinafter referred to as “Note”) shall be subject to the following conditions, thus:
                    </p>
                    <div class="ml-5">
                        <ol type="a">
                            <li>
                                The Maker shall turn over post-dated checks to the Payee in accordance with the above schedule of payment.
                            </li>
                            <li>
                                Any default or delay in the payment of any installment shall bear a penalty of three percent (3%) per month.
                            </li>
                            <li>
                                The Maker shall have the right at any time or from time to time to pay all or a portion of the principal without premium or penalty.
                            </li>
                            <li>
                                The Maker hereby waives demand, diligence, presentment for payment, protest or notice of demand and exercise of any option hereunder.
                            </li>
                            <li>
                                The Maker agrees that the granting of any extension or extensions of time for payment of any sum or sums due hereunder, or for the performance of any covenant, condition or agreement hereof or the release of other or additional security, shall in no way release or discharge the liability of the Maker.
                            </li>
                            <li>
                                Time is of the essence in this Note and each and every term and provision herein is intended to insure the prompt payment of the obligation.
                            </li>
                        </ol>
                    </div>
                </div>

                <div>
                    <p>
                        IN WITNESS WHEREOF, the Maker has hereunto set ${Pronoun("his", b.borrowerGender, b.legalPersonality, "borrower")} hand this _______________ in _______________.
                    </p>
                </div>

                <br />
                <br />

                <div class="signatory text-right">
                    <span class="signatory-inner text-center">
                        <span class="signatory-name text-uppercase font-weight-bold dynamic-data">
                            ${b.legalPersonality==="Natural Person"?
                                borrowerName:
                                `<span>
                                    ${borrowerCorporationRepresentativeName}<br />
                                    <span className="text-capitalize font-weight-normal">${borrowerCorporationName}</span><br />
                                    <span className="text-capitalize font-weight-normal">${borrowerCorporationRepresentativePosition}</span>
                                </span>`}
                        </span>
                        <br />
                        <span class="signatory-position font-italic">
                            <em>Maker</em>
                        </span>
                    </span>
                    <div class="clearfix"></div>
                </div>
                
            </div>
        </div>`;

        let fn = "promissory_note_contracts_ph_"+Date.now();
        let dn = this.state.formName;

        const meta = {
            title: "Your custom Promissory Note is now ready for download",
            description: "Your custom Promissory Note is now ready for download"
        }
        
        return(
            <div className="page page-inner page-contract">
                <Meta {...meta}/>
                <Loading />
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
                                <ContractCreate />
                                <ProgressBar percentage={Math.floor((4/4)*100)} />

                                {/* Final step starts here */}
                                <div className="my-5 text-center">
                                    <FormFinal 
                                        contract_html={contract_html} 
                                        fn={fn} 
                                        dn={dn} 
                                        formPath={this.state.formPath}
                                        details={this.state.details} />
                                </div>

								<FormGuarantee />

								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 4/4</p>
									<Link to={this.state.formPath+"/3"} className="btn btn-lightblue mr-2">Go Back and Edit</Link>
								</div>

                            </div>
                            <div className="col-12 col-md-7 right-preview">
                                <Preview {...this.state} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PromissoryNoteStep4;


// WEBPACK FOOTER //
// ./src/pages/contracts/business/promissory-note/PromissoryNoteStep4.js